import { useCallback, useMemo, useRef, useState } from 'react';
import { debounce } from 'lodash-es';
const EMPTY_OPTIONS = [];
export function useAsyncOptions(loadOptions) {
    let debounceMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    const [options, setOptions] = useState(EMPTY_OPTIONS);
    const [loading, setLoading] = useState(false);
    const requestId = useRef(0);
    const search = useMemo(()=>debounce((query)=>{
            if (!loadOptions) return;
            if (!query) {
                requestId.current += 1;
                setOptions(EMPTY_OPTIONS);
                setLoading(false);
                return;
            }
            const currentRequest = ++requestId.current;
            setLoading(true);
            loadOptions(query).then((result)=>{
                if (currentRequest !== requestId.current) return;
                setOptions(result);
            }).finally(()=>{
                if (currentRequest !== requestId.current) return;
                setLoading(false);
            });
        }, debounceMs), [
        loadOptions,
        debounceMs
    ]);
    const cancel = useCallback(()=>{
        search.cancel();
        requestId.current += 1;
    }, [
        search
    ]);
    return {
        options,
        loading,
        search,
        cancel
    };
}
